import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

export default function SelectLabels({
  categoryData,
  text,
  valueKey,
  labelKey,
  onSelectChange,
  previousValue,
  prevId,
}) {
  // console.log(previousValue, prevId);
  const [selectedValue, setSelectedValue] = React.useState("");
  React.useEffect(() => {
    if (previousValue) {
      setSelectedValue(previousValue);
      // onSelectChange(prevId);
      // console.log("previous-value", previousValue);
      // onSelectChange(previousValue);
    }
  }, [previousValue]);

  const handleChange = (event) => {
    const selectedItem = categoryData.find(
      (item) => item[valueKey] === event.target.value
    );
    setSelectedValue(event.target.value);
    // console.log("event.target.value", event.target.value);
    onSelectChange(selectedItem);
  };

  return (
    <div className="w-80">
      {/* <FormControl sx={{ m: 1, minWidth: 120 }}>
          <InputLabel id="demo-simple-select-helper-label">Age</InputLabel>
        </FormControl> */}
      <FormControl
        required
        sx={{ width: "100%", height: "100%", minWidth: 200 }}
      >
        <Select
          value={selectedValue}
          onChange={handleChange}
          displayEmpty
          inputProps={{ "aria-label": "Without label" }}
          sx={{
            width: "150px",
            height: "100%",
            p: 1, // Remove padding
            "& .MuiOutlinedInput-input": { p: 0 }, // Remove padding from input
            "& .MuiSelect-select": { p: 0 },
          }}
        >
          <MenuItem value="" sx={{ padding: " 0px", margin: "0px " }}>
            <em>{text}</em>
          </MenuItem>
          {Array.isArray(categoryData) &&
            categoryData.map((item) => (
              <MenuItem key={item[valueKey]} value={item[valueKey]}>
                {item[labelKey]}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </div>
  );
}
